import React, { useEffect, useState } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import ConfirmationDialog from "../../components/Dialog/ConfirmationDialog";
import {
  Card,
  CardContent,
  CardHeader,
  Stack,
  Step,
  StepLabel,
  Stepper,
} from "@mui/material";
import MaterialTypography from "../../components/MaterialTypography";
import MaterialBox from "../../components/MaterialBox";
import MaterialButton from "../../components/MaterialButton";
import OnsiteEmployeeDetails from "./OnsiteEmployeeDetails";
import TravelDocuments from "./TravelDocuments";
import { useUserDetails } from "../../context/auth";
import { addOnsiteService, editOnsiteService } from "./onsiteService";
import { useLoading } from "../../context/loading";
import Swal from "sweetalert2";
import { useNavigate, useLocation } from "react-router-dom";
import request from "graphql-request";
import BASEURL from "../Utils/Baseurl";
import { getOnsiteEmployeeDetails } from "./onsitequery";

const OnsiteForm = () => {
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });

  const [employeeData, setEmployeeData] = useState({
    type: "",
    employeeName: "",
    employeeId: "",
    email: "",
    phoneNo: "",
    experience: "",
    passportNo: "",
    joiningDate: "",
    projectName: "",
    typeStatus: "unchecked",
    employeeNameStatus: "unchecked",
    employeeIdStatus: "unchecked",
    emailStatus: "unchecked",
    phoneNoStatus: "unchecked",
    experienceStatus: "unchecked",
    passportNoStatus: "unchecked",
    joiningDateStatus: "unchecked",
    projectNameStatus: "unchecked",
  });

  const [isValidPhone, setIsValidPhone] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState("in");

  const [travelDocuments, setTravelDocuments] = useState([
    {
      documentSubmissionMail: "",
      documentComments: "",
      medicalTestApplied: "",
      medicalTestAppliedComments: "",
      medicalTestReport: "",
      medicalTestReportComments: "",
      biometric: "",
      biometricComments: "",
      documentSubmission: "",
      documentSubmissionComments: "",
      documentReturned: "",
      documentReturnedComments: "",
      visaStamped: "",
      visaStampedComments: "",
      startFromIndia: "",
      startFromIndiaComments: "",
      reachedOnSite: "",
      reachedOnSiteComments: "",
      visaExpiryDays: "",
      visaExpiryDaysStatus: "unchecked",
      visaExpiryDate: "",
      visaExpiryComments: "",
      startFromOnsite: "",
      startFromOnsiteComments: "",
      returnedToCountry: "",
      returnedToCountryComments: "",
      formIsopen: true,
    },
  ]);

  const [activeStep, setActiveStep] = useState(0);
  const [inputDisbled, setInputDisbled] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const id = location?.state?.id;
  const type = location?.state?.type;

  useEffect(() => {
    if (type == "view") {
      setInputDisbled(true);
    } else {
      setInputDisbled(false);
    }

    if (type == "edit") {
      setIsValidPhone(true);
    } else {
      setIsValidPhone(false);
    }
  }, [type]);

  const { user } = useUserDetails();
  const { setCirleLoading } = useLoading();

  const user_id = user?.id;

  const handleNext = () => {
    setActiveStep(activeStep + 1);
  };

  const handlePrveious = () => {
    setActiveStep(activeStep - 1);
  };
  useEffect(() => {
    if (id) {
      fetchUserData();
    }
  }, [id]);
  const fetchUserData = async () => {
    setCirleLoading(true);
    try {
      const res = await request(BASEURL, getOnsiteEmployeeDetails, {
        id: id,
      });

      const data = res?.getOnsiteEmployeeDetails;

      const documentData =
        res?.getOnsiteEmployeeDetails?.onsitedoumentationsSet;

      setTravelDocuments(documentData);

      setEmployeeData({
        type: { value: data?.type, label: data?.type },
        employeeName: data?.employeeName,
        employeeId: data?.employeeId,
        email: data?.email,
        phoneNo: data?.phoneNo,
        experience: data?.experience,
        passportNo: data?.passportNo,
        joiningDate: data?.joiningDate,
        projectName: data?.projectName,
        typeStatus: "success",
        employeeNameStatus: "success",
        employeeIdStatus: "success",
        emailStatus: "success",
        phoneNoStatus: "success",
        experienceStatus: "success",
        passportNoStatus: "success",
        joiningDateStatus: "success",
        projectNameStatus: "success",
      });
    } catch (err) {
    } finally {
      setCirleLoading(false);
    }
  };

  const steps = ["Employee Details", "Travel Document Details"];

  const handleSumbit = async () => {
    const values = {
      employeeName: employeeData?.employeeName,
      employeeId: employeeData?.employeeId,
      email: employeeData?.email,
      phoneNo: employeeData?.phoneNo,
      experience: employeeData?.experience,
      passportNo: employeeData?.passportNo,
      joiningDate: employeeData?.joiningDate,
      projectName: employeeData?.projectName,
      type: employeeData?.type?.label,
    };
    setCirleLoading(true);
    const { status, message } = await addOnsiteService(
      values,
      travelDocuments,
      user_id
    );
    setCirleLoading(false);
    if (status) {
      Swal.fire({
        title: message,
        icon: "success",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ok",
      }).then(() => {
        navigate("/onsite");
      });
    } else if (!status) {
      Swal.fire({
        title: message,
        icon: "error",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ok",
      });
    }
  };
  const handleUpdate = async () => {
    const values = {
      id: id,
      employeeName: employeeData?.employeeName,
      employeeId: employeeData?.employeeId,
      email: employeeData?.email,
      phoneNo: employeeData?.phoneNo,
      experience: employeeData?.experience,
      passportNo: employeeData?.passportNo,
      joiningDate: employeeData?.joiningDate,
      projectName: employeeData?.projectName,
      type: employeeData?.type?.label,
    };

    const modifiedArray = travelDocuments.map((v, i) => ({
      id: v?.id,
      documentSubmissionMail: v?.documentSubmissionMail || null,
      documentComments: v?.documentComments,
      medicalTestApplied: v?.medicalTestApplied || null,

      medicalTestAppliedComments: v?.medicalTestAppliedComments,

      medicalTestReport: v?.medicalTestReport || null,

      medicalTestReportComments: v?.medicalTestReportComments,

      biometric: v?.biometric || null,

      biometricComments: v?.biometricComments,

      documentSubmission: v?.documentSubmission || null,

      documentSubmissionComments: v?.documentSubmissionComments,

      documentReturned: v?.documentReturned || null,

      documentReturnedComments: v?.documentReturnedComments,

      visaStamped: v?.visaStamped || null,

      visaStampedComments: v?.visaStampedComments,
      startFromIndiaComments: v?.startFromIndiaComments,
      startFromIndia: v?.startFromIndia || null,

      reachedOnSite: v?.reachedOnSite || null,

      reachedOnSiteComments: v?.reachedOnSiteComments,

      visaExpiryDays: v?.visaExpiryDays,

      visaExpiryDate: v?.visaExpiryDate || null,

      visaExpiryComments: v?.visaExpiryComments,

      startFromOnsite: v?.startFromOnsite || null,

      startFromOnsiteComments: v?.startFromOnsiteComments,

      returnedToCountry: v?.returnedToCountry || null,

      returnedToCountryComments: v?.returnedToCountryComments,
    }));
    setCirleLoading(true);
    const { status, message } = await editOnsiteService(values, modifiedArray);
    setCirleLoading(false);
    if (status) {
      Swal.fire({
        title: message,
        icon: "success",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ok",
      }).then(() => {
        navigate("/onsite");
      });
    } else if (!status) {
      Swal.fire({
        title: message,
        icon: "error",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ok",
      });
    }
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      employeeData.typeStatus === "success" &&
      employeeData.emailStatus === "success" &&
      employeeData.employeeIdStatus === "success" &&
      employeeData.employeeNameStatus === "success" &&
      employeeData?.phoneNoStatus ==="success" &&
      employeeData.experienceStatus === "success" &&
      employeeData.joiningDateStatus === "success" &&
      employeeData.passportNoStatus === "success" &&
      employeeData.projectNameStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };
  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      <Card>
        <CardHeader
          title={
            <>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
              >
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                    {type == "edit"
                      ? "Edit On-Site Details"
                      : type == "view"
                      ? "View On-Site Details"
                      : "Add On-Site Details"}
                  </MaterialTypography>
                </Stack>
              </Stack>
              <MaterialBox>
                <Stepper
                  activeStep={activeStep}
                  alternativeLabel
                  style={{
                    padding: "0px",
                    marginTop: "40px",
                    marginBottom: "20px",
                  }}
                >
                  {steps.map((v, i) => (
                    <Step key={i}>
                      <StepLabel>{v}</StepLabel>
                    </Step>
                  ))}
                </Stepper>
              </MaterialBox>
            </>
          }
        />
        <CardContent sx={{ minHeight: "70vh" }}>
          {activeStep == 0 && (
            <OnsiteEmployeeDetails
              employeeData={employeeData}
              setEmployeeData={setEmployeeData}
              inputDisbled={inputDisbled}
              setIsValidPhone={setIsValidPhone}
            />
          )}

          {activeStep == 1 && (
            <TravelDocuments
              travelDocuments={travelDocuments}
              setTravelDocuments={setTravelDocuments}
              inputDisbled={inputDisbled}
              formtype={type}
            />
          )}
          <MaterialBox
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
          >
            <MaterialButton
              onClick={
                type == "edit"
                  ? handleUpdate
                  : type == "view"
                  ? () => navigate("/onsite")
                  : handleSumbit
              }
              sx={{ m: 2 }}
              variant="gradient"
              color="dark"
              disabled={
                type == "edit"
                  ? !checkAllFields()
                  : type == "view"
                  ? false
                  : !checkAllFields()
              }
            >
              {type == "edit"
                ? "Update"
                : type == "view"
                ? "Back to Onsite List"
                : "Submit"}
            </MaterialButton>

            <MaterialButton
              onClick={activeStep == 0 ? handleNext : handlePrveious}
              sx={{ m: 2 }}
              variant="gradient"
              color="dark"
              disabled={
                type == "edit"
                  ? !checkAllFields()
                  : type == "view"
                  ? false
                  : !checkAllFields()
              }
            >
              {activeStep == 0 ? "Next" : "Previous"}
            </MaterialButton>
          </MaterialBox>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
};

export default OnsiteForm;
